/**
 * Ring buffer for GPS heading values.
 * Used to compute a delayed heading for trailer articulation —
 * the trailer "follows" with a heading from ~2 seconds ago.
 */
export class HeadingBuffer {
  private buffer: { heading: number; timestamp: number }[] = [];
  private maxSize: number;

  constructor(maxSize = 30) {
    this.maxSize = maxSize;
  }

  push(heading: number, timestamp: number): void {
    this.buffer.push({ heading, timestamp });
    if (this.buffer.length > this.maxSize) this.buffer.shift();
  }

  /** Get the heading from approximately delayMs milliseconds ago.
   *  Returns null if buffer is empty. */
  getDelayedHeading(delayMs = 2000): number | null {
    if (this.buffer.length === 0) return null;
    if (this.buffer.length === 1) return this.buffer[0].heading;

    const now = this.buffer[this.buffer.length - 1].timestamp;
    const targetTime = now - delayMs;

    // Find the entry closest to (but not exceeding) the target time
    let best = this.buffer[0];
    for (const entry of this.buffer) {
      if (entry.timestamp <= targetTime) best = entry;
      else break;
    }
    return best.heading;
  }

  clear(): void {
    this.buffer = [];
  }
}
